import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import { getTypePipeline, leadRecent, leadsByCampaign, leadsByStage, leadsByYear } from "../dashboardAPI";
import { ApexOptions } from "apexcharts";
interface ChartOptions {
  series: number[];
  options: ApexOptions;
}
interface Progress {
  newLeads: number;
  totalLeads: number;
  convertedLeads: number;
  leadConversionRate: number;
}
const route = all_routes;
const LeadsDashboard = () => {
  const [chartOptions2, setChartOptions2] = useState<any>({
    series: [
      {
        name: "Leads",
        type: "column",
        data: [],
        color: "#77D882",
      },
      {
        name: "Conversion Rate (%)",
        type: "line",
        data: [],
        color: "#409EFF",
      },
    ],
    chart: {
      height: 300,
      type: "line",
    },
    plotOptions: {
      bar: {
        columnWidth: "40%",
      },
    },
    stroke: {
      width: [0, 3],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
      formatter: function (val: number, opts: any) {
        if (opts.seriesIndex === 1) {
          return `${val}%`;
        }
        return val;
      },
    },
    xaxis: {
      categories: [],
    },
    yaxis: [
      {
        title: {
          text: "Leads",
        },
      },
      {
        opposite: true,
        title: {
          text: "Conversion Rate (%)",
        },
        labels: {
          formatter: function (val: number) {
            return `${val}%`;
          },
        },
      },
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (val: number, opts: any) {
          if (opts.seriesIndex === 1) return `${val}%`;
          return val;
        },
      },
    },
  });

  const [selectedPeriodCampaign, setSelectedPeriodCampaign] = useState<number>(30);
  const fetchLeadsByCampaign = async (selectedPeriodCampaign: number) => {
    try {
      const response = await leadsByCampaign(selectedPeriodCampaign);
      console.log("res:", response);

      const items = response.data.data;

      const numOfLeadsArr: number[] = items.map((item: any) => item.numOfLeads);

      const conversionRateArr: number[] = items.map((item: any) =>
        parseFloat(item.conversionRate.toFixed(2))
      );

      const campaignNamesArr: string[] = items.map(
        (item: any) => item.campaignName
      );

      const maxValue = Math.max(...numOfLeadsArr, 0);
      const roundedMax = Math.ceil(maxValue / 100) * 100;

      setChartOptions2((prev: any) => ({
        ...prev,
        series: [
          {
            name: "Leads",
            data: numOfLeadsArr,
            color: "#77D882",
          },
          {
            name: "Conversion Rate (%)",
            data: conversionRateArr,
            color: "#409EFF",
          },
        ],
        xaxis: {
          ...prev.xaxis,
          categories: campaignNamesArr,
        },
        yaxis: {
          max: roundedMax,
        },
      }));
    } catch (error) {
      console.error("error:", error);
    }
  };


  useEffect(() => {
    fetchLeadsByCampaign(selectedPeriodCampaign);
  }, [selectedPeriodCampaign]);


  const [chartOptions3, setChartOptions3] = useState<ChartOptions>({
    series: [44, 55, 13, 43],
    options: {
      chart: {
        width: 400,
        height: 300,
        type: "pie",
      },
      legend: {
        position: "bottom",
      },
      labels: [],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 275,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });

  const [selectedPeriodPie, setSelectedPeriodPie] = useState<number>(30);

  const fetchPieData = async (selectedPeriodPie: number) => {
    try {
      const leadsResponse = await leadsByStage(selectedPeriodPie);
      const typeResponse = await getTypePipeline("LEAD");

      const leadsData: number[] = leadsResponse.data.data;
      const labelObjects: string[] = typeResponse.data.data;

      const labels = labelObjects
        .map((item: any) => item.name);

      setChartOptions3((prevOptions) => ({
        ...prevOptions,
        series: leadsData,
        options: {
          ...prevOptions.options,
          labels: labels,
        },
      }));
    } catch (error) {
      console.error("err", error);
    }
  };

  const [leadProgressData, setLeadProgressData] = useState<Progress>();
  useEffect(() => {
    const fetchLeadProgess = async () => {
      try {
        const response = await leadRecent(7);
        setLeadProgressData(response.data.data);
      } catch (error) {
        console.error("err", error);
      }
    };
    fetchLeadProgess();
  }, []);

  useEffect(() => {
    fetchPieData(selectedPeriodPie);
  }, [selectedPeriodPie]);

  const [chartSeries, setChartSeries] = useState<any[]>([]);
  const [chartOptions4, setChartOptions4] = useState<ApexOptions>({
    chart: {
      height: 300,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#4A00E5"],
    dataLabels: {
      enabled: false,
    },
    title: {
      text: "",
      align: "left",
    },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
    },
    yaxis: {
      min: 0,
      max: 60,
      tickAmount: 5,
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });

  useEffect(() => {
    const fetchLeadsByYear = async () => {
      try {
        const response = await leadsByYear();
        const data: number[] = response.data.data;

        const maxValue = Math.max(...data);
        const roundedMax = Math.ceil(maxValue / 100) * 100;

        setChartSeries([
          {
            name: "Leads",
            data: data,
          },
        ]);

        setChartOptions4((prevOptions) => ({
          ...prevOptions,
          yaxis: {
            ...prevOptions.yaxis,
            max: roundedMax,
          },
        }));
      } catch (error) {
        console.error("Failed to fetch leads by year:", error);
      }
    };

    fetchLeadsByYear();
  }, []);

  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center ">
                  <div className="col-md-4">
                    <h3 className="page-title">Leads Dashboard</h3>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-3 col-lg-6">
                  <div className="campaign-box bg-danger-light">
                    <div className="campaign-img">
                      <p>New Lead</p>
                    </div>
                    <h2>{leadProgressData?.newLeads}</h2>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6">
                  <div className="campaign-box bg-warning-light">
                    <div className="campaign-img">
                      <p>Total Lead</p>
                    </div>
                    <h2>{leadProgressData?.totalLeads}</h2>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6">
                  <div className="campaign-box bg-purple-light">
                    <div className="campaign-img">
                      <p>Converted Lead</p>
                    </div>
                    <h2>{leadProgressData?.convertedLeads}</h2>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6">
                  <div className="campaign-box bg-success-light">
                    <div className="campaign-img">
                      <p>Conversion Rate</p>
                    </div>
                    <h2>{leadProgressData?.convertedLeads}%</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="card w-100">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4>
                      <i className="ti ti-grip-vertical me-1" />
                      Leads By Stage
                    </h4>
                    <div className="dropdown">
                      <Link
                        className="dropdown-toggle"
                        data-bs-toggle="dropdown"
                        to="#"
                      >
                        Last {selectedPeriodPie} Days
                      </Link>
                      <div className="dropdown-menu dropdown-menu-end">
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodPie(30)}
                        >
                          Last 30 Days
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodPie(15)}
                        >
                          Last 15 Days
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodPie(7)}
                        >
                          Last 7 Days
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div id="leadpiechart">
                    <Chart
                      options={chartOptions3.options}
                      series={chartOptions3.series}
                      type="pie"
                      width={chartOptions3.options?.chart?.width}
                      height={chartOptions3.options?.chart?.height}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4>
                      <i className="ti ti-grip-vertical me-1" />
                      Leads By Campaign
                    </h4>
                    <div className="dropdown">
                      <Link
                        className="dropdown-toggle"
                        data-bs-toggle="dropdown"
                        to="#"
                      >
                        Last {selectedPeriodCampaign} Days
                      </Link>
                      <div className="dropdown-menu dropdown-menu-end">
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodCampaign(30)}
                        >
                          Last 30 Days
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodCampaign(15)}
                        >
                          Last 15 Days
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodCampaign(7)}
                        >
                          Last 7 Days
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body ">
                  <div id="won-chart">
                    {" "}
                    <Chart
                      options={chartOptions2}
                      series={chartOptions2.series}
                      type={chartOptions2.chart.type}
                      height={chartOptions2.chart.height}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card w-100">
                  <div className="card-header border-0 pb-0">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4>
                        <i className="ti ti-grip-vertical me-1" />
                        Leads By Year
                      </h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <div id="contact-report">
                      <Chart
                        options={chartOptions4}
                        series={chartSeries}
                        type="area"
                        height={chartOptions4.chart?.height ?? 300}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadsDashboard;
